import { render, staticRenderFns } from "./ApexCartsMixed.vue?vue&type=template&id=5220eedb&"
import script from "./ApexCartsMixed.vue?vue&type=script&lang=js&"
export * from "./ApexCartsMixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports